export default __webpack_public_path__ + "static/media/Programming.082835ce.png";